import React from 'react';
import { Modal } from 'react-bootstrap';
import './CustomModal.scss';

interface ICustomModal {
  show: boolean;
  onHide?: () => void;
  title?: string;
  body: JSX.Element;
  className?: string;
  close?: boolean;
  size?: 'sm' | 'lg' | 'xl';
  backdrop?: 'static' | true;
}

const CustomModal: React.FC<ICustomModal> = ({
    size,
    show,
    onHide,
    title,
    body,
    className,
    close,
    backdrop
  }) => {
  return (
    <Modal
      size={size}
      show={show}
      onHide={onHide}
      centered
      className={`generic-modal ${className}`}
      backdrop={backdrop}
    >
      <Modal.Header closeButton={close}>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{body}</Modal.Body>
    </Modal>
  );
};

export default CustomModal;
